export const LOCALES = { EN: "en", PT: "pt" };

export const LOCALE_LABELS: Record<string, string> = {
  en: "English",
  pt: "Português",
};

export const DEFAULT_LOCALE = LOCALES.PT;
